import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Form, Formik } from "formik";
import FormController from "../formFields/FormController";
import labels from "../../dictionaries/labels.json";
import * as Yup from "yup";

const FilterComponent = ({
  initialValues = {},
  filterFields = [],
  changeFilters,
  resetFilters,
  validationSchema = Yup.object(),
}) => {
  const onSubmit = (formik) => {
    changeFilters(formik.values);
    if (resetFilters) {
      Object.keys(formik.values).map((value) => {
        formik.setFieldValue(value, initialValues[value]);
      });
    }
  };

  return (
    <>
      <Formik validationSchema={validationSchema} initialValues={initialValues}>
        {(formik) => (
          <Box>
            <Card>
              <CardHeader
                title={
                  <Typography variant="h3">
                    {labels.Labels.TableLabels.search}
                  </Typography>
                }
              />
              <Divider></Divider>
              <CardContent id="filter-component-cardcontent">
                <Form>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "50px",
                      height: "100%",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                    }}
                  >
                    {filterFields.map((filter) => {
                      return (
                        <Box
                          key={filter.name}
                          flexGrow={
                            filter.control === "selectWithCheckboxes" ? 1 : 0
                          }
                        >
                          <FormController
                            id={filter.name}
                            key={filter.name}
                            required
                            size="small"
                            control={filter.control}
                            type={filter.type}
                            label={filter.label}
                            name={filter.name}
                            formik={formik}
                            options={filter.options}
                            {...filter}
                          />
                        </Box>
                      );
                    })}
                    <Box
                      sx={{ alignSelf: "center", mt: 4, ml: { lg: "auto" } }}
                    >
                      <Button
                        size="large"
                        variant="outlined"
                        onClick={() => onSubmit(formik)}
                      >
                        Αναζήτηση
                      </Button>
                    </Box>
                  </Box>
                </Form>
              </CardContent>
            </Card>
          </Box>
        )}
      </Formik>
    </>
  );
};

export default FilterComponent;
